var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-loading",class:{ compact: _vm.compact }},[_c('span',{staticClass:"loading-ring"}),_c('span',{staticClass:"loading-text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }